import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TiktokPixelService {

  private pixelInitialized = false;
  private readonly PIXEL_ID = 'CV3NC7JC77UD0HO3F3VG'
  private scriptElement: HTMLScriptElement | null = null;
  private noscriptElement: HTMLElement | null = null;

  constructor(
    @Inject(DOCUMENT) private document: Document
  ) { }

  /**
   * Inicializa el píxel de TikTok si aún no se ha inicializado
   * @param eventoId ID opcional del evento para inicializar solo para ciertos eventos
   */
  initPixel(eventoId?: number): void {
    // Si quieres que solo se inicialice para eventos específicos
    if (eventoId !== undefined && eventoId !== 1157) {
      this.removePixel()
      return;
    }
    
    // Si ya se inicializó, no lo hagas de nuevo
    if (this.pixelInitialized) {
      return;
    }
    
    try {
      const script = this.document.createElement('script');
      script.innerHTML = `
        !function (w, d, t) {
          w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(
          var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js",o=n&&n.partner;ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script")
          ;n.type="text/javascript",n.async=!0,n.src=r+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};
          ttq.load('${this.PIXEL_ID}');
          ttq.page();
        }(window, document, 'ttq');
      `;
      
      this.document.head.appendChild(script);
      this.pixelInitialized = true;
    } catch (error) {
      console.error('Error al inicializar TikTok Pixel:', error);
    }
  }
  
  /**
   * Añade el elemento noscript para soporte sin JavaScript
   * @param eventoId ID opcional del evento para añadir solo para ciertos eventos
   */
  addNoScriptElement(eventoId?: number): void {
    // Si quieres que solo se añada para eventos específicos
    if (eventoId !== undefined && eventoId !== 1157) {
      return;
    }
    
    const noscript = this.document.createElement('noscript');
    const img = this.document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://analytics.tiktok.com/i18n/pixel/event.png?sdkid=${this.PIXEL_ID}&noscript=1`;
    
    noscript.appendChild(img);
    this.document.body.appendChild(noscript);
  }

  /**
   * Elimina el píxel de TikTok del DOM
   */
  removePixel(): void {
    // Eliminar el script si existe
    if (this.scriptElement && this.scriptElement.parentNode) {
      this.scriptElement.parentNode.removeChild(this.scriptElement);
      this.scriptElement = null;
    }
    
    // Eliminar el noscript si existe
    if (this.noscriptElement && this.noscriptElement.parentNode) {
      this.noscriptElement.parentNode.removeChild(this.noscriptElement);
      this.noscriptElement = null;
    }
    
    // Eliminar la referencia global de ttq si es posible
    if (window['ttq']) {
      try {
        // Intentar limpiar la variable global (no siempre es posible)
        window['ttq'] = undefined;
      } catch (e) {
        console.warn('No se pudo eliminar completamente la referencia a ttq');
      }
    }
    
    this.pixelInitialized = false;
  }



}
